import React from 'react';
import {FormNameEnum} from 'filters-selections/enums';
import {TextInputSelection} from '../TextInputSelection/TextInputSelection';

export const InstrumentNameTextInput = () => {
  return <TextInputSelection name={FormNameEnum.instrumentName} label="Instrument Name" />;
};
